import { AppVersion } from "@common/interfaces";
import { IInfOperation, FixupRelPath } from '@common/utils';
import { fn } from '@common/utils';
import resolveToError = fn.resolveToError;
import { DialogService } from '@services/dialogservice';
import { AsObservableArray } from '../navkendo';
import { KWFAdminService } from './KWFApplication.Admin';

/** Controller for Uploading a Path for KWFAPP */
export class KWFAppUpdateController {
    static $inject = ["$scope", "$q", "$timeout", "KWFAdminService", "DialogService"];
    constructor($scope: ng.IScope, private $q: ng.IQService, private $timeout: ng.ITimeoutService, private kwfAdmin: KWFAdminService, private DialogService: DialogService) {
        var me = $scope["Update"] = this;

        var actToggle = me.ToggleShowAllFiles = <IInfOperation>{
            Enabled: true, Checked: false,
            Execute: () => me.filterFiles(actToggle.Checked = !actToggle.Checked)
        };

        //#region Drag & Drop Functionality
        var ddInfo = $scope["DDInfo"] = {
            Counter: 0,
            Check: (enter: boolean) => {
                if (enter) {
                    ddInfo.Counter++;
                }
                 else {
                    ddInfo.Counter--;
                 }
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
             }
        };
        var dZone = $("[ng-controller='KWFAppUpdateController']").parent();
        dZone.on("dragenter.navAdmin", e => {
            e.preventDefault();
            ddInfo.Check(true);
        }).on("dragleave.navAdmin", e => {
            ddInfo.Check(false);
        }).on("dragover.navAdmin", e => {
            e.stopPropagation();
            e.preventDefault();
            var dEvent = <DragEvent>e.originalEvent;
            dEvent.dataTransfer.dropEffect = 'copy';
        }).on("drop.navAdmin", (e) => {
            e.stopPropagation();
            e.preventDefault();
            var dEvent = <DragEvent>e.originalEvent;
            var files = dEvent.dataTransfer && dEvent.dataTransfer.files; // Array of all files
            if (files && files.length == 1) {
                me.FileChanged(files[0]);
            }
            ddInfo.Check(false);
        });
        $scope.$on("$destroy", () => dZone.off(".navAdmin"));
        //#endregion
    }
    public ToggleShowAllFiles: IInfOperation;
    /** Container of Current Files */
    public UploadFiles = AsObservableArray(new Array<IKWFUpdateFileInfo>());
    /** Grid Options to Display File Information */
    public PatchFilesOptions: kendo.ui.GridOptions;
    public CurrentInfo: IKWFUpdateInfo;
    public ValidatedFile: File;
    public ValidatedKey: string;
    public ServerVersion: AppVersion;
    public NewVersion: AppVersion;
    private ValidatedFileInput: HTMLInputElement | File;
    /** Current Error Message */
    public CurrentError: string;
    public InOperation = false;
    /** React on File  Changed : Prepare from File data */
    public FileChanged(fileInput: HTMLInputElement | File) {
        var file = <File>fileInput;
        if (fileInput instanceof HTMLInputElement) {
            file = fileInput.files[0];
        }
        return this.Prepare(file).then(() => {
            this.ValidatedFileInput = fileInput;
        }, err => {
            this.resetFileInput(fileInput);
        });
    }

    /** Prepare from given File info */
    Prepare(file: File) {
        var fd = new FormData();
        fd.append('file', file);
        this.Reset();
        return this.wrapOperation(this.uploadPatch(fd).then((info) => {
            this.ValidatedFile = file;
            this.ValidatedKey = info && info.ExecuteKey;
            this.ServerVersion = info && info.ServerVersion;
            this.NewVersion = info && info.NewVersion;
            this.setCurrentInfo(info);
            return file;
        }));
    }

    /** Commit from Prepared File Info */
    Commit() {
        var me = this;
        return this.DialogService.WhenConfirm("Soll von Version '" + me.vInfo(me.ServerVersion) + "' auf Version '" + me.vInfo(me.NewVersion) + "' upgedatet werden?")
            .then(() => {
                var fd = new FormData();
                fd.append('file', this.ValidatedFile);
                return this.wrapOperation(this.uploadPatch(fd, this.ValidatedKey).then((info) => {
                    me.setCurrentInfo(info);
                }));
            }).then(() => me.kwfAdmin.ForceClientsRefresh(true));
    }

    Reset() {
        delete this.CurrentError;
        delete this.ValidatedFile;
        delete this.ValidatedKey;
        delete this.NewVersion;
        delete this.ServerVersion;
        this.setCurrentInfo(undefined);
        if (this.ValidatedFileInput) {
            this.resetFileInput(this.ValidatedFileInput);
            delete this.ValidatedFileInput;
        }
    }

    private uploadPatch(formData: FormData, executeKey: string = null) {
        // Problem : we could $http.post , but wasn't able to correctly consume on server side (in some situations no response to Client at all (!?!)
        var result = this.$q.defer<IKWFUpdateInfo>();
        $.ajax({
            url: FixupRelPath('/infoma.Web.KWF3/AppUpdate/UploadPatch?' + fn.EncodeQueryData({ executeKey: executeKey })),
            type: 'POST',
            data: formData,
            cache: false,
            dataType: 'json',
            processData: false, // Don't process the files
            contentType: false, // Set content type to false as jQuery will tell the server its a query string request
            success: function (data, textStatus, jqXHR) {
                try {
                    resolveToError(data, true);
                    result.resolve(data);
                } catch (err) {
                    result.reject(err);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // Handle errors here
                result.reject(errorThrown || textStatus);
            }
        });

        return result.promise;
    }

    private setCurrentInfo(info: IKWFUpdateInfo) {
        var newFiles = (info && info.Files || []);
        let map = fn.ToDictionary(newFiles, "FullName");

        function getOrCreateDirectoryEntryName(parentPath: string, pathFrags: string[]) {
            var parent = map[parentPath || ""] || map[parentPath + "/"];
            if (parentPath && !parent) {
                parent = map[parentPath] = <IKWFUpdateFileInfo>{
                    FullName: parentPath, Error: "", IsChanged: false, Exists: true, IsNew: false,
                    IsDirectory: true, IsDelete: false, IsFile: false,
                    Name: pathFrags[pathFrags.length - 2] || "",
                    parentId: getOrCreateDirectoryEntryName(pathFrags.slice(0, pathFrags.length - 2).join("/"), pathFrags.slice(0, pathFrags.length - 2)),
                    Operation: {
                        Info: ""
                    },
                    Unchanged: true,
                };
                newFiles.push(parent);
            }
            return (parent || { FullName: "" }).FullName;

        }

        fn.ToArray(newFiles).forEach(f => {
            var path = f.FullName;
            if (path.lastIndexOf("/") == path.length - 1)
                path = path.substr(0, path.length - 1);
            var pathFrags = path.split("/");
            f.Name = pathFrags[pathFrags.length - 1];
            var parentPath = path.substr(0, path.lastIndexOf("/"));
            f.parentId = getOrCreateDirectoryEntryName(parentPath, pathFrags);
            var isChange = f.Unchanged === false || f.IsChanged || f.IsDelete || f.IsNew;
            f.Unchanged = !isChange;
        });

        newFiles.filter(item => item.IsDirectory).forEach(dir => {
            dir.IsChanged = dir.IsChanged || !this.UploadFiles.filter(item => item.parentId == dir.FullName).every(f => !(f.IsChanged || f.IsDelete));
        });

        this.CurrentInfo = info;
        this.UploadFiles.splice(0, this.UploadFiles.length, ...newFiles);

        if (this.UploadFiles.length > 0) {
            delete this["TreeListOptions"];
            //Problem : How to Refresh dataSource?
            this.$timeout(() => {
                this["TreeListOptions"] = <kendo.ui.TreeListOptions>{
                    dataSource: new kendo.data.TreeListDataSource({
                        data: fn.ToArray(this.UploadFiles),
                        schema: {
                            model: {
                                id: "FullName",
                                expanded: true,
                                defaults: { parentId: "" }
                            }
                        }
                    }),
                    columns: [
                        { template: '<span title="#: Operation.Info #"><span class="#: IsDelete ? "k-icon k-i-close" : (IsNew ? "k-icon k-i-plus" :(IsChanged ? "k-icon k-i-pencil" : "k-icon k-i-tick")) #" ></span>&nbsp;#: Name #</span>' },
                        { field: "Operation.Info", title: "Information" }
                    ],
                    resizable: true
                };

                this.filterFiles();
            });
        }
    }

    private filterFiles(filter?: boolean) {
        filter = filter === undefined && this.ToggleShowAllFiles ? this.ToggleShowAllFiles.Checked : filter;
        var x = <kendo.ui.TreeListOptions>this["TreeListOptions"];
        var ds = x && <kendo.data.TreeListDataSource>x.dataSource;
        if (ds) {
            if (filter)
                ds.filter([{ field: "Unchanged", value: false }]);
            else
                ds.filter([]);
        }
    }

    private wrapOperation<T>(p: PromiseLike<T>) {
        if (p && !this.InOperation) {
            p = p.then(fn.noop, err => {
                this.CurrentError = resolveToError(err);
                return this.DialogService.ShowError(this.CurrentError).then(() => {
                    throw err;
                });
            });
            p.then(() => this.InOperation = false, () => this.InOperation = false);
            delete this.CurrentError;
            this.InOperation = true;
        }
        return p;
    }

    private resetFileInput(fileInput: HTMLInputElement | File) {
        if (fileInput instanceof HTMLInputElement) {
            // In Case Of Error : Clear File input content
            var jFile = $(fileInput);
            var form = <HTMLFormElement>jFile.wrap('<form>').closest('form').get(0);
            form.reset();
            jFile.unwrap();
        }
    }

    private vInfo(v: AppVersion) {
        return (v && v.Version) + " (" + (v && v.PatchLevel) + ")";
    }
}

interface IKWFUpdateInfo {
    ExecuteKey: string;
    ServerVersion: AppVersion;
    NewVersion: AppVersion;
    Files: Array<IKWFUpdateFileInfo>;
}

interface IKWFUpdateFileInfo {
    FullName: string;
    IsChanged: boolean;
    IsDelete: boolean;
    Exists: boolean;
    IsNew: boolean;
    IsDirectory: boolean;
    IsFile: boolean;
    Operation: {
        Info: string
    };

    // Client Side attached
    parentId: string;
    Name: string;
    Unchanged?: boolean;
}
